import React from 'react';
import styled from 'styled-components';

import DetailedCarMoreDetails from '@/components/DetailedCarMoreDetails';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function MoreDetails() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data || !data.content.description) {
    return null;
  }

  const {
    content: { description },
  } = data;

  return (
    <Component>
      <DetailedCarMoreDetails text={description} />
    </Component>
  );
}

export default MoreDetails;

const Component = styled.div`
  margin-top: 50px;
`;
